// source: common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
goog.object.extend(proto, google_protobuf_any_pb);
var enum_pb = require('./enum_pb.js');
goog.object.extend(proto, enum_pb);
goog.exportSymbol('proto.common.AnalyticsEth', null, global);
goog.exportSymbol('proto.common.AnalyticsReply', null, global);
goog.exportSymbol('proto.common.AnalyticsReply.AnalyticsCase', null, global);
goog.exportSymbol('proto.common.AnalyticsSol', null, global);
goog.exportSymbol('proto.common.AuditEth', null, global);
goog.exportSymbol('proto.common.AuditReply', null, global);
goog.exportSymbol('proto.common.AuditReply.AuditCase', null, global);
goog.exportSymbol('proto.common.AuditSol', null, global);
goog.exportSymbol('proto.common.AuthTokens', null, global);
goog.exportSymbol('proto.common.Decimals', null, global);
goog.exportSymbol('proto.common.EmptyReply', null, global);
goog.exportSymbol('proto.common.ErrorDescription', null, global);
goog.exportSymbol('proto.common.GeneralReply', null, global);
goog.exportSymbol('proto.common.GeneralRequest', null, global);
goog.exportSymbol('proto.common.KeyPagingRequest', null, global);
goog.exportSymbol('proto.common.LocalizedText', null, global);
goog.exportSymbol('proto.common.Order', null, global);
goog.exportSymbol('proto.common.OrderTrigger', null, global);
goog.exportSymbol('proto.common.PagingRequest', null, global);
goog.exportSymbol('proto.common.PriorityFee', null, global);
goog.exportSymbol('proto.common.PriorityFee.PriorityfeeCase', null, global);
goog.exportSymbol('proto.common.RequestResult', null, global);
goog.exportSymbol('proto.common.TimeInterval', null, global);
goog.exportSymbol('proto.common.Tokenomics', null, global);
goog.exportSymbol('proto.common.TransactionSettings', null, global);
goog.exportSymbol('proto.common.UnsubscribeRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GeneralRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GeneralRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GeneralRequest.displayName = 'proto.common.GeneralRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.GeneralReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.GeneralReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.GeneralReply.displayName = 'proto.common.GeneralReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.UnsubscribeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.UnsubscribeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.UnsubscribeRequest.displayName = 'proto.common.UnsubscribeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.RequestResult = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.RequestResult.repeatedFields_, null);
};
goog.inherits(proto.common.RequestResult, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.RequestResult.displayName = 'proto.common.RequestResult';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.EmptyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.EmptyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.EmptyReply.displayName = 'proto.common.EmptyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.ErrorDescription = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.common.ErrorDescription.repeatedFields_, null);
};
goog.inherits(proto.common.ErrorDescription, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.ErrorDescription.displayName = 'proto.common.ErrorDescription';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.PagingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.PagingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.PagingRequest.displayName = 'proto.common.PagingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.KeyPagingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.KeyPagingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.KeyPagingRequest.displayName = 'proto.common.KeyPagingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.LocalizedText = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.LocalizedText, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.LocalizedText.displayName = 'proto.common.LocalizedText';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.TimeInterval = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.TimeInterval, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.TimeInterval.displayName = 'proto.common.TimeInterval';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.AuthTokens = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.AuthTokens, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.AuthTokens.displayName = 'proto.common.AuthTokens';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.TransactionSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.TransactionSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.TransactionSettings.displayName = 'proto.common.TransactionSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.PriorityFee = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.common.PriorityFee.oneofGroups_);
};
goog.inherits(proto.common.PriorityFee, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.PriorityFee.displayName = 'proto.common.PriorityFee';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.AnalyticsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.common.AnalyticsReply.oneofGroups_);
};
goog.inherits(proto.common.AnalyticsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.AnalyticsReply.displayName = 'proto.common.AnalyticsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.AnalyticsEth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.AnalyticsEth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.AnalyticsEth.displayName = 'proto.common.AnalyticsEth';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.AnalyticsSol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.AnalyticsSol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.AnalyticsSol.displayName = 'proto.common.AnalyticsSol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.Tokenomics = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.Tokenomics, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.Tokenomics.displayName = 'proto.common.Tokenomics';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.AuditReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.common.AuditReply.oneofGroups_);
};
goog.inherits(proto.common.AuditReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.AuditReply.displayName = 'proto.common.AuditReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.AuditSol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.AuditSol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.AuditSol.displayName = 'proto.common.AuditSol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.AuditEth = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.AuditEth, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.AuditEth.displayName = 'proto.common.AuditEth';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.Order = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.Order, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.Order.displayName = 'proto.common.Order';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.OrderTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.OrderTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.OrderTrigger.displayName = 'proto.common.OrderTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.common.Decimals = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.common.Decimals, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.common.Decimals.displayName = 'proto.common.Decimals';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GeneralRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GeneralRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GeneralRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GeneralRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: (f = msg.getMessage()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    method: jspb.Message.getFieldWithDefault(msg, 3, ""),
    authorization: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GeneralRequest}
 */
proto.common.GeneralRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GeneralRequest;
  return proto.common.GeneralRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GeneralRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GeneralRequest}
 */
proto.common.GeneralRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMethod(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GeneralRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GeneralRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GeneralRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GeneralRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.common.GeneralRequest.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.GeneralRequest} returns this
 */
proto.common.GeneralRequest.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Any message = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.common.GeneralRequest.prototype.getMessage = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.common.GeneralRequest} returns this
*/
proto.common.GeneralRequest.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GeneralRequest} returns this
 */
proto.common.GeneralRequest.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GeneralRequest.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string method = 3;
 * @return {string}
 */
proto.common.GeneralRequest.prototype.getMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.GeneralRequest} returns this
 */
proto.common.GeneralRequest.prototype.setMethod = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.GeneralRequest} returns this
 */
proto.common.GeneralRequest.prototype.clearMethod = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GeneralRequest.prototype.hasMethod = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string authorization = 4;
 * @return {string}
 */
proto.common.GeneralRequest.prototype.getAuthorization = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.GeneralRequest} returns this
 */
proto.common.GeneralRequest.prototype.setAuthorization = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.GeneralRequest} returns this
 */
proto.common.GeneralRequest.prototype.clearAuthorization = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GeneralRequest.prototype.hasAuthorization = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.GeneralReply.prototype.toObject = function(opt_includeInstance) {
  return proto.common.GeneralReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.GeneralReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GeneralReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    requestid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    message: (f = msg.getMessage()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.GeneralReply}
 */
proto.common.GeneralReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.GeneralReply;
  return proto.common.GeneralReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.GeneralReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.GeneralReply}
 */
proto.common.GeneralReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestid(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.GeneralReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.GeneralReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.GeneralReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.GeneralReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequestid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional string requestId = 1;
 * @return {string}
 */
proto.common.GeneralReply.prototype.getRequestid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.GeneralReply} returns this
 */
proto.common.GeneralReply.prototype.setRequestid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Any message = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.common.GeneralReply.prototype.getMessage = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/**
 * @param {?proto.google.protobuf.Any|undefined} value
 * @return {!proto.common.GeneralReply} returns this
*/
proto.common.GeneralReply.prototype.setMessage = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.GeneralReply} returns this
 */
proto.common.GeneralReply.prototype.clearMessage = function() {
  return this.setMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.GeneralReply.prototype.hasMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.UnsubscribeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.UnsubscribeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.UnsubscribeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.UnsubscribeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    unsubscribe: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.UnsubscribeRequest}
 */
proto.common.UnsubscribeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.UnsubscribeRequest;
  return proto.common.UnsubscribeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.UnsubscribeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.UnsubscribeRequest}
 */
proto.common.UnsubscribeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnsubscribe(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.UnsubscribeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.UnsubscribeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.UnsubscribeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.UnsubscribeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnsubscribe();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool unsubscribe = 1;
 * @return {boolean}
 */
proto.common.UnsubscribeRequest.prototype.getUnsubscribe = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.UnsubscribeRequest} returns this
 */
proto.common.UnsubscribeRequest.prototype.setUnsubscribe = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.RequestResult.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.RequestResult.prototype.toObject = function(opt_includeInstance) {
  return proto.common.RequestResult.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.RequestResult} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.RequestResult.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuccess: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.common.ErrorDescription.toObject, includeInstance),
    errortrace: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.RequestResult}
 */
proto.common.RequestResult.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.RequestResult;
  return proto.common.RequestResult.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.RequestResult} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.RequestResult}
 */
proto.common.RequestResult.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIssuccess(value);
      break;
    case 2:
      var value = new proto.common.ErrorDescription;
      reader.readMessage(value,proto.common.ErrorDescription.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrortrace(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.RequestResult.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.RequestResult.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.RequestResult} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.RequestResult.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.common.ErrorDescription.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bool isSuccess = 1;
 * @return {boolean}
 */
proto.common.RequestResult.prototype.getIssuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.RequestResult} returns this
 */
proto.common.RequestResult.prototype.setIssuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated ErrorDescription errors = 2;
 * @return {!Array<!proto.common.ErrorDescription>}
 */
proto.common.RequestResult.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.common.ErrorDescription>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.ErrorDescription, 2));
};


/**
 * @param {!Array<!proto.common.ErrorDescription>} value
 * @return {!proto.common.RequestResult} returns this
*/
proto.common.RequestResult.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ErrorDescription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ErrorDescription}
 */
proto.common.RequestResult.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ErrorDescription, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.RequestResult} returns this
 */
proto.common.RequestResult.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};


/**
 * optional string errorTrace = 3;
 * @return {string}
 */
proto.common.RequestResult.prototype.getErrortrace = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.RequestResult} returns this
 */
proto.common.RequestResult.prototype.setErrortrace = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.RequestResult} returns this
 */
proto.common.RequestResult.prototype.clearErrortrace = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.RequestResult.prototype.hasErrortrace = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.EmptyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.common.EmptyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.EmptyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.EmptyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    result: (f = msg.getResult()) && proto.common.RequestResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.EmptyReply}
 */
proto.common.EmptyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.EmptyReply;
  return proto.common.EmptyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.EmptyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.EmptyReply}
 */
proto.common.EmptyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.RequestResult;
      reader.readMessage(value,proto.common.RequestResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.EmptyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.EmptyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.EmptyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.EmptyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.RequestResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional RequestResult result = 1;
 * @return {?proto.common.RequestResult}
 */
proto.common.EmptyReply.prototype.getResult = function() {
  return /** @type{?proto.common.RequestResult} */ (
    jspb.Message.getWrapperField(this, proto.common.RequestResult, 1));
};


/**
 * @param {?proto.common.RequestResult|undefined} value
 * @return {!proto.common.EmptyReply} returns this
*/
proto.common.EmptyReply.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.EmptyReply} returns this
 */
proto.common.EmptyReply.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.EmptyReply.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.common.ErrorDescription.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.ErrorDescription.prototype.toObject = function(opt_includeInstance) {
  return proto.common.ErrorDescription.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.ErrorDescription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.ErrorDescription.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    details: jspb.Message.getFieldWithDefault(msg, 3, ""),
    localizedtextList: jspb.Message.toObjectList(msg.getLocalizedtextList(),
    proto.common.LocalizedText.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.ErrorDescription}
 */
proto.common.ErrorDescription.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.ErrorDescription;
  return proto.common.ErrorDescription.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.ErrorDescription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.ErrorDescription}
 */
proto.common.ErrorDescription.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDetails(value);
      break;
    case 4:
      var value = new proto.common.LocalizedText;
      reader.readMessage(value,proto.common.LocalizedText.deserializeBinaryFromReader);
      msg.addLocalizedtext(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.ErrorDescription.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.ErrorDescription.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.ErrorDescription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.ErrorDescription.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDetails();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLocalizedtextList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.common.LocalizedText.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 code = 1;
 * @return {number}
 */
proto.common.ErrorDescription.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.ErrorDescription} returns this
 */
proto.common.ErrorDescription.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.common.ErrorDescription.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.ErrorDescription} returns this
 */
proto.common.ErrorDescription.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string details = 3;
 * @return {string}
 */
proto.common.ErrorDescription.prototype.getDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.ErrorDescription} returns this
 */
proto.common.ErrorDescription.prototype.setDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated LocalizedText localizedText = 4;
 * @return {!Array<!proto.common.LocalizedText>}
 */
proto.common.ErrorDescription.prototype.getLocalizedtextList = function() {
  return /** @type{!Array<!proto.common.LocalizedText>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.common.LocalizedText, 4));
};


/**
 * @param {!Array<!proto.common.LocalizedText>} value
 * @return {!proto.common.ErrorDescription} returns this
*/
proto.common.ErrorDescription.prototype.setLocalizedtextList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.common.LocalizedText=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.LocalizedText}
 */
proto.common.ErrorDescription.prototype.addLocalizedtext = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.common.LocalizedText, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.common.ErrorDescription} returns this
 */
proto.common.ErrorDescription.prototype.clearLocalizedtextList = function() {
  return this.setLocalizedtextList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.PagingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.PagingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.PagingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.PagingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lastknownid: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.PagingRequest}
 */
proto.common.PagingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.PagingRequest;
  return proto.common.PagingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.PagingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.PagingRequest}
 */
proto.common.PagingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastknownid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.PagingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.PagingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.PagingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.PagingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint32 offset = 1;
 * @return {number}
 */
proto.common.PagingRequest.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.PagingRequest} returns this
 */
proto.common.PagingRequest.prototype.setOffset = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.PagingRequest} returns this
 */
proto.common.PagingRequest.prototype.clearOffset = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.PagingRequest.prototype.hasOffset = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint32 limit = 2;
 * @return {number}
 */
proto.common.PagingRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.PagingRequest} returns this
 */
proto.common.PagingRequest.prototype.setLimit = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.PagingRequest} returns this
 */
proto.common.PagingRequest.prototype.clearLimit = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.PagingRequest.prototype.hasLimit = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string lastKnownId = 3;
 * @return {string}
 */
proto.common.PagingRequest.prototype.getLastknownid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.PagingRequest} returns this
 */
proto.common.PagingRequest.prototype.setLastknownid = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.PagingRequest} returns this
 */
proto.common.PagingRequest.prototype.clearLastknownid = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.PagingRequest.prototype.hasLastknownid = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.KeyPagingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.common.KeyPagingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.KeyPagingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.KeyPagingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
    continuationtoken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.KeyPagingRequest}
 */
proto.common.KeyPagingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.KeyPagingRequest;
  return proto.common.KeyPagingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.KeyPagingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.KeyPagingRequest}
 */
proto.common.KeyPagingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContinuationtoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.KeyPagingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.KeyPagingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.KeyPagingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.KeyPagingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 limit = 1;
 * @return {number}
 */
proto.common.KeyPagingRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.KeyPagingRequest} returns this
 */
proto.common.KeyPagingRequest.prototype.setLimit = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.KeyPagingRequest} returns this
 */
proto.common.KeyPagingRequest.prototype.clearLimit = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.KeyPagingRequest.prototype.hasLimit = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string continuationToken = 2;
 * @return {string}
 */
proto.common.KeyPagingRequest.prototype.getContinuationtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.KeyPagingRequest} returns this
 */
proto.common.KeyPagingRequest.prototype.setContinuationtoken = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.KeyPagingRequest} returns this
 */
proto.common.KeyPagingRequest.prototype.clearContinuationtoken = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.KeyPagingRequest.prototype.hasContinuationtoken = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.LocalizedText.prototype.toObject = function(opt_includeInstance) {
  return proto.common.LocalizedText.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.LocalizedText} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.LocalizedText.toObject = function(includeInstance, msg) {
  var f, obj = {
    locale: jspb.Message.getFieldWithDefault(msg, 1, ""),
    text: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.LocalizedText}
 */
proto.common.LocalizedText.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.LocalizedText;
  return proto.common.LocalizedText.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.LocalizedText} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.LocalizedText}
 */
proto.common.LocalizedText.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocale(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.LocalizedText.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.LocalizedText.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.LocalizedText} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.LocalizedText.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLocale();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string locale = 1;
 * @return {string}
 */
proto.common.LocalizedText.prototype.getLocale = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.LocalizedText} returns this
 */
proto.common.LocalizedText.prototype.setLocale = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string text = 2;
 * @return {string}
 */
proto.common.LocalizedText.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.LocalizedText} returns this
 */
proto.common.LocalizedText.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.TimeInterval.prototype.toObject = function(opt_includeInstance) {
  return proto.common.TimeInterval.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.TimeInterval} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.TimeInterval.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    unit: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.TimeInterval}
 */
proto.common.TimeInterval.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.TimeInterval;
  return proto.common.TimeInterval.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.TimeInterval} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.TimeInterval}
 */
proto.common.TimeInterval.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {!proto.enumeration.TimeUnit} */ (reader.readEnum());
      msg.setUnit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.TimeInterval.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.TimeInterval.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.TimeInterval} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.TimeInterval.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.common.TimeInterval.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.TimeInterval} returns this
 */
proto.common.TimeInterval.prototype.setValue = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.TimeInterval} returns this
 */
proto.common.TimeInterval.prototype.clearValue = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TimeInterval.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional enumeration.TimeUnit unit = 2;
 * @return {!proto.enumeration.TimeUnit}
 */
proto.common.TimeInterval.prototype.getUnit = function() {
  return /** @type {!proto.enumeration.TimeUnit} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.enumeration.TimeUnit} value
 * @return {!proto.common.TimeInterval} returns this
 */
proto.common.TimeInterval.prototype.setUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.AuthTokens.prototype.toObject = function(opt_includeInstance) {
  return proto.common.AuthTokens.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.AuthTokens} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuthTokens.toObject = function(includeInstance, msg) {
  var f, obj = {
    accesstoken: jspb.Message.getFieldWithDefault(msg, 1, ""),
    refreshtoken: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.AuthTokens}
 */
proto.common.AuthTokens.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.AuthTokens;
  return proto.common.AuthTokens.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.AuthTokens} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.AuthTokens}
 */
proto.common.AuthTokens.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccesstoken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefreshtoken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.AuthTokens.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.AuthTokens.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.AuthTokens} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuthTokens.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccesstoken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRefreshtoken();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string accessToken = 1;
 * @return {string}
 */
proto.common.AuthTokens.prototype.getAccesstoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.AuthTokens} returns this
 */
proto.common.AuthTokens.prototype.setAccesstoken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string refreshToken = 2;
 * @return {string}
 */
proto.common.AuthTokens.prototype.getRefreshtoken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.AuthTokens} returns this
 */
proto.common.AuthTokens.prototype.setRefreshtoken = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.TransactionSettings.prototype.toObject = function(opt_includeInstance) {
  return proto.common.TransactionSettings.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.TransactionSettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.TransactionSettings.toObject = function(includeInstance, msg) {
  var f, obj = {
    antimev: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    preapprove: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    autoapprove: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    antirug: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    gaslimit: (f = msg.getGaslimit()) && proto.common.Decimals.toObject(includeInstance, f),
    priorityfee: (f = msg.getPriorityfee()) && proto.common.PriorityFee.toObject(includeInstance, f),
    briberyamount: (f = msg.getBriberyamount()) && proto.common.Decimals.toObject(includeInstance, f),
    slippage: (f = msg.getSlippage()) && proto.common.Decimals.toObject(includeInstance, f),
    expiration: (f = msg.getExpiration()) && proto.common.TimeInterval.toObject(includeInstance, f),
    transferonblacklist: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    fof: jspb.Message.getBooleanFieldWithDefault(msg, 11, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.TransactionSettings}
 */
proto.common.TransactionSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.TransactionSettings;
  return proto.common.TransactionSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.TransactionSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.TransactionSettings}
 */
proto.common.TransactionSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAntimev(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPreapprove(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAutoapprove(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAntirug(value);
      break;
    case 5:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setGaslimit(value);
      break;
    case 6:
      var value = new proto.common.PriorityFee;
      reader.readMessage(value,proto.common.PriorityFee.deserializeBinaryFromReader);
      msg.setPriorityfee(value);
      break;
    case 7:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setBriberyamount(value);
      break;
    case 8:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setSlippage(value);
      break;
    case 9:
      var value = new proto.common.TimeInterval;
      reader.readMessage(value,proto.common.TimeInterval.deserializeBinaryFromReader);
      msg.setExpiration(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTransferonblacklist(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFof(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.TransactionSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.TransactionSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.TransactionSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.TransactionSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getGaslimit();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getPriorityfee();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.common.PriorityFee.serializeBinaryToWriter
    );
  }
  f = message.getBriberyamount();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getSlippage();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getExpiration();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.common.TimeInterval.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeBool(
      11,
      f
    );
  }
};


/**
 * optional bool antiMev = 1;
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.getAntimev = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.setAntimev = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearAntimev = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasAntimev = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool preApprove = 2;
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.getPreapprove = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.setPreapprove = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearPreapprove = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasPreapprove = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool autoApprove = 3;
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.getAutoapprove = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.setAutoapprove = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearAutoapprove = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasAutoapprove = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool antiRug = 4;
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.getAntirug = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.setAntirug = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearAntirug = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasAntirug = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Decimals gasLimit = 5;
 * @return {?proto.common.Decimals}
 */
proto.common.TransactionSettings.prototype.getGaslimit = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 5));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.TransactionSettings} returns this
*/
proto.common.TransactionSettings.prototype.setGaslimit = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearGaslimit = function() {
  return this.setGaslimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasGaslimit = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PriorityFee priorityFee = 6;
 * @return {?proto.common.PriorityFee}
 */
proto.common.TransactionSettings.prototype.getPriorityfee = function() {
  return /** @type{?proto.common.PriorityFee} */ (
    jspb.Message.getWrapperField(this, proto.common.PriorityFee, 6));
};


/**
 * @param {?proto.common.PriorityFee|undefined} value
 * @return {!proto.common.TransactionSettings} returns this
*/
proto.common.TransactionSettings.prototype.setPriorityfee = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearPriorityfee = function() {
  return this.setPriorityfee(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasPriorityfee = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Decimals briberyAmount = 7;
 * @return {?proto.common.Decimals}
 */
proto.common.TransactionSettings.prototype.getBriberyamount = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 7));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.TransactionSettings} returns this
*/
proto.common.TransactionSettings.prototype.setBriberyamount = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearBriberyamount = function() {
  return this.setBriberyamount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasBriberyamount = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Decimals slippage = 8;
 * @return {?proto.common.Decimals}
 */
proto.common.TransactionSettings.prototype.getSlippage = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 8));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.TransactionSettings} returns this
*/
proto.common.TransactionSettings.prototype.setSlippage = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearSlippage = function() {
  return this.setSlippage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasSlippage = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional TimeInterval expiration = 9;
 * @return {?proto.common.TimeInterval}
 */
proto.common.TransactionSettings.prototype.getExpiration = function() {
  return /** @type{?proto.common.TimeInterval} */ (
    jspb.Message.getWrapperField(this, proto.common.TimeInterval, 9));
};


/**
 * @param {?proto.common.TimeInterval|undefined} value
 * @return {!proto.common.TransactionSettings} returns this
*/
proto.common.TransactionSettings.prototype.setExpiration = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearExpiration = function() {
  return this.setExpiration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasExpiration = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool transferOnBlacklist = 10;
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.getTransferonblacklist = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.setTransferonblacklist = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearTransferonblacklist = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasTransferonblacklist = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional bool fof = 11;
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.getFof = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.setFof = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.TransactionSettings} returns this
 */
proto.common.TransactionSettings.prototype.clearFof = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.TransactionSettings.prototype.hasFof = function() {
  return jspb.Message.getField(this, 11) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.common.PriorityFee.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.common.PriorityFee.PriorityfeeCase = {
  PRIORITYFEE_NOT_SET: 0,
  FIXED: 1,
  MULTIPLIER: 2
};

/**
 * @return {proto.common.PriorityFee.PriorityfeeCase}
 */
proto.common.PriorityFee.prototype.getPriorityfeeCase = function() {
  return /** @type {proto.common.PriorityFee.PriorityfeeCase} */(jspb.Message.computeOneofCase(this, proto.common.PriorityFee.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.PriorityFee.prototype.toObject = function(opt_includeInstance) {
  return proto.common.PriorityFee.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.PriorityFee} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.PriorityFee.toObject = function(includeInstance, msg) {
  var f, obj = {
    fixed: (f = msg.getFixed()) && proto.common.Decimals.toObject(includeInstance, f),
    multiplier: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.PriorityFee}
 */
proto.common.PriorityFee.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.PriorityFee;
  return proto.common.PriorityFee.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.PriorityFee} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.PriorityFee}
 */
proto.common.PriorityFee.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setFixed(value);
      break;
    case 2:
      var value = /** @type {!proto.enumeration.PriorityFeeMultiplier} */ (reader.readEnum());
      msg.setMultiplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.PriorityFee.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.PriorityFee.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.PriorityFee} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.PriorityFee.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFixed();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.enumeration.PriorityFeeMultiplier} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional Decimals fixed = 1;
 * @return {?proto.common.Decimals}
 */
proto.common.PriorityFee.prototype.getFixed = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 1));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.PriorityFee} returns this
*/
proto.common.PriorityFee.prototype.setFixed = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.common.PriorityFee.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.PriorityFee} returns this
 */
proto.common.PriorityFee.prototype.clearFixed = function() {
  return this.setFixed(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.PriorityFee.prototype.hasFixed = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional enumeration.PriorityFeeMultiplier multiplier = 2;
 * @return {!proto.enumeration.PriorityFeeMultiplier}
 */
proto.common.PriorityFee.prototype.getMultiplier = function() {
  return /** @type {!proto.enumeration.PriorityFeeMultiplier} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.enumeration.PriorityFeeMultiplier} value
 * @return {!proto.common.PriorityFee} returns this
 */
proto.common.PriorityFee.prototype.setMultiplier = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.common.PriorityFee.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.PriorityFee} returns this
 */
proto.common.PriorityFee.prototype.clearMultiplier = function() {
  return jspb.Message.setOneofField(this, 2, proto.common.PriorityFee.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.PriorityFee.prototype.hasMultiplier = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.common.AnalyticsReply.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.common.AnalyticsReply.AnalyticsCase = {
  ANALYTICS_NOT_SET: 0,
  ANALYTICSSOL: 1,
  ANALYTICSETH: 2
};

/**
 * @return {proto.common.AnalyticsReply.AnalyticsCase}
 */
proto.common.AnalyticsReply.prototype.getAnalyticsCase = function() {
  return /** @type {proto.common.AnalyticsReply.AnalyticsCase} */(jspb.Message.computeOneofCase(this, proto.common.AnalyticsReply.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.AnalyticsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.common.AnalyticsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.AnalyticsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AnalyticsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    analyticssol: (f = msg.getAnalyticssol()) && proto.common.AnalyticsSol.toObject(includeInstance, f),
    analyticseth: (f = msg.getAnalyticseth()) && proto.common.AnalyticsEth.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.AnalyticsReply}
 */
proto.common.AnalyticsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.AnalyticsReply;
  return proto.common.AnalyticsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.AnalyticsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.AnalyticsReply}
 */
proto.common.AnalyticsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.AnalyticsSol;
      reader.readMessage(value,proto.common.AnalyticsSol.deserializeBinaryFromReader);
      msg.setAnalyticssol(value);
      break;
    case 2:
      var value = new proto.common.AnalyticsEth;
      reader.readMessage(value,proto.common.AnalyticsEth.deserializeBinaryFromReader);
      msg.setAnalyticseth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.AnalyticsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.AnalyticsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.AnalyticsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AnalyticsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnalyticssol();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.AnalyticsSol.serializeBinaryToWriter
    );
  }
  f = message.getAnalyticseth();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.AnalyticsEth.serializeBinaryToWriter
    );
  }
};


/**
 * optional AnalyticsSol analyticsSol = 1;
 * @return {?proto.common.AnalyticsSol}
 */
proto.common.AnalyticsReply.prototype.getAnalyticssol = function() {
  return /** @type{?proto.common.AnalyticsSol} */ (
    jspb.Message.getWrapperField(this, proto.common.AnalyticsSol, 1));
};


/**
 * @param {?proto.common.AnalyticsSol|undefined} value
 * @return {!proto.common.AnalyticsReply} returns this
*/
proto.common.AnalyticsReply.prototype.setAnalyticssol = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.common.AnalyticsReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsReply} returns this
 */
proto.common.AnalyticsReply.prototype.clearAnalyticssol = function() {
  return this.setAnalyticssol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsReply.prototype.hasAnalyticssol = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AnalyticsEth analyticsEth = 2;
 * @return {?proto.common.AnalyticsEth}
 */
proto.common.AnalyticsReply.prototype.getAnalyticseth = function() {
  return /** @type{?proto.common.AnalyticsEth} */ (
    jspb.Message.getWrapperField(this, proto.common.AnalyticsEth, 2));
};


/**
 * @param {?proto.common.AnalyticsEth|undefined} value
 * @return {!proto.common.AnalyticsReply} returns this
*/
proto.common.AnalyticsReply.prototype.setAnalyticseth = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.common.AnalyticsReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsReply} returns this
 */
proto.common.AnalyticsReply.prototype.clearAnalyticseth = function() {
  return this.setAnalyticseth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsReply.prototype.hasAnalyticseth = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.AnalyticsEth.prototype.toObject = function(opt_includeInstance) {
  return proto.common.AnalyticsEth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.AnalyticsEth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AnalyticsEth.toObject = function(includeInstance, msg) {
  var f, obj = {
    buytax: (f = msg.getBuytax()) && proto.common.Decimals.toObject(includeInstance, f),
    selltax: (f = msg.getSelltax()) && proto.common.Decimals.toObject(includeInstance, f),
    transfertax: (f = msg.getTransfertax()) && proto.common.Decimals.toObject(includeInstance, f),
    clog: (f = msg.getClog()) && proto.common.Decimals.toObject(includeInstance, f),
    honeypot: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    lockedliquidity: (f = msg.getLockedliquidity()) && proto.common.Decimals.toObject(includeInstance, f),
    burnedliquidity: (f = msg.getBurnedliquidity()) && proto.common.Decimals.toObject(includeInstance, f),
    holders: jspb.Message.getFieldWithDefault(msg, 8, 0),
    maxbuy: (f = msg.getMaxbuy()) && proto.common.Decimals.toObject(includeInstance, f),
    maxsell: (f = msg.getMaxsell()) && proto.common.Decimals.toObject(includeInstance, f),
    cantsell: jspb.Message.getFieldWithDefault(msg, 11, 0),
    selllimit: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    deployerwallet: jspb.Message.getFieldWithDefault(msg, 13, ""),
    deployerholdings: (f = msg.getDeployerholdings()) && proto.common.Decimals.toObject(includeInstance, f),
    createdat: (f = msg.getCreatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    verifiedcontract: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    renounced: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    notproxycontract: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    ownerwallet: jspb.Message.getFieldWithDefault(msg, 19, ""),
    selllimitperblock: jspb.Message.getBooleanFieldWithDefault(msg, 20, false),
    topholders: (f = msg.getTopholders()) && proto.common.Decimals.toObject(includeInstance, f),
    creatorholdings: (f = msg.getCreatorholdings()) && proto.common.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.AnalyticsEth}
 */
proto.common.AnalyticsEth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.AnalyticsEth;
  return proto.common.AnalyticsEth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.AnalyticsEth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.AnalyticsEth}
 */
proto.common.AnalyticsEth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setBuytax(value);
      break;
    case 2:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setSelltax(value);
      break;
    case 3:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setTransfertax(value);
      break;
    case 4:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setClog(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHoneypot(value);
      break;
    case 6:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setLockedliquidity(value);
      break;
    case 7:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setBurnedliquidity(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHolders(value);
      break;
    case 9:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setMaxbuy(value);
      break;
    case 10:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setMaxsell(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCantsell(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelllimit(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeployerwallet(value);
      break;
    case 14:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setDeployerholdings(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedat(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerifiedcontract(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRenounced(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNotproxycontract(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerwallet(value);
      break;
    case 20:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSelllimitperblock(value);
      break;
    case 21:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setTopholders(value);
      break;
    case 22:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setCreatorholdings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.AnalyticsEth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.AnalyticsEth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.AnalyticsEth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AnalyticsEth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBuytax();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getSelltax();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getTransfertax();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getClog();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getLockedliquidity();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getBurnedliquidity();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getMaxbuy();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMaxsell();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeBool(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getDeployerholdings();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getCreatedat();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeBool(
      16,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeBool(
      17,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeBool(
      18,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeString(
      19,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeBool(
      20,
      f
    );
  }
  f = message.getTopholders();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getCreatorholdings();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional Decimals buyTax = 1;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getBuytax = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 1));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setBuytax = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearBuytax = function() {
  return this.setBuytax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasBuytax = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Decimals sellTax = 2;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getSelltax = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setSelltax = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearSelltax = function() {
  return this.setSelltax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasSelltax = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Decimals transferTax = 3;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getTransfertax = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 3));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setTransfertax = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearTransfertax = function() {
  return this.setTransfertax(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasTransfertax = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Decimals clog = 4;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getClog = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setClog = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearClog = function() {
  return this.setClog(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasClog = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool honeypot = 5;
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.getHoneypot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setHoneypot = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearHoneypot = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasHoneypot = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Decimals lockedLiquidity = 6;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getLockedliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 6));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setLockedliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearLockedliquidity = function() {
  return this.setLockedliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasLockedliquidity = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional Decimals burnedLiquidity = 7;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getBurnedliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 7));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setBurnedliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearBurnedliquidity = function() {
  return this.setBurnedliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasBurnedliquidity = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 holders = 8;
 * @return {number}
 */
proto.common.AnalyticsEth.prototype.getHolders = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setHolders = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearHolders = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasHolders = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional Decimals maxBuy = 9;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getMaxbuy = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 9));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setMaxbuy = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearMaxbuy = function() {
  return this.setMaxbuy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasMaxbuy = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Decimals maxSell = 10;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getMaxsell = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 10));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setMaxsell = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearMaxsell = function() {
  return this.setMaxsell(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasMaxsell = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional int64 cantSell = 11;
 * @return {number}
 */
proto.common.AnalyticsEth.prototype.getCantsell = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setCantsell = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearCantsell = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasCantsell = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional bool sellLimit = 12;
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.getSelllimit = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setSelllimit = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearSelllimit = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasSelllimit = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string deployerWallet = 13;
 * @return {string}
 */
proto.common.AnalyticsEth.prototype.getDeployerwallet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setDeployerwallet = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearDeployerwallet = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasDeployerwallet = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional Decimals deployerHoldings = 14;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getDeployerholdings = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 14));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setDeployerholdings = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearDeployerholdings = function() {
  return this.setDeployerholdings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasDeployerholdings = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp createdAt = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.common.AnalyticsEth.prototype.getCreatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setCreatedat = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearCreatedat = function() {
  return this.setCreatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool verifiedContract = 16;
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.getVerifiedcontract = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setVerifiedcontract = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearVerifiedcontract = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasVerifiedcontract = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional bool renounced = 17;
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.getRenounced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setRenounced = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearRenounced = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasRenounced = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional bool notProxyContract = 18;
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.getNotproxycontract = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setNotproxycontract = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearNotproxycontract = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasNotproxycontract = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string ownerWallet = 19;
 * @return {string}
 */
proto.common.AnalyticsEth.prototype.getOwnerwallet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setOwnerwallet = function(value) {
  return jspb.Message.setField(this, 19, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearOwnerwallet = function() {
  return jspb.Message.setField(this, 19, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasOwnerwallet = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional bool sellLimitPerBlock = 20;
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.getSelllimitperblock = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 20, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.setSelllimitperblock = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearSelllimitperblock = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasSelllimitperblock = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional Decimals topHolders = 21;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getTopholders = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 21));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setTopholders = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearTopholders = function() {
  return this.setTopholders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasTopholders = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional Decimals creatorHoldings = 22;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsEth.prototype.getCreatorholdings = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 22));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsEth} returns this
*/
proto.common.AnalyticsEth.prototype.setCreatorholdings = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsEth} returns this
 */
proto.common.AnalyticsEth.prototype.clearCreatorholdings = function() {
  return this.setCreatorholdings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsEth.prototype.hasCreatorholdings = function() {
  return jspb.Message.getField(this, 22) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.AnalyticsSol.prototype.toObject = function(opt_includeInstance) {
  return proto.common.AnalyticsSol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.AnalyticsSol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AnalyticsSol.toObject = function(includeInstance, msg) {
  var f, obj = {
    burnedliquidity: (f = msg.getBurnedliquidity()) && proto.common.Decimals.toObject(includeInstance, f),
    pooledcrypto: (f = msg.getPooledcrypto()) && proto.common.Decimals.toObject(includeInstance, f),
    pooledtokens: (f = msg.getPooledtokens()) && proto.common.Decimals.toObject(includeInstance, f),
    mintauthority: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    freezeauthority: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    holders: jspb.Message.getFieldWithDefault(msg, 6, 0),
    deployerwallet: jspb.Message.getFieldWithDefault(msg, 7, ""),
    deployerholdings: (f = msg.getDeployerholdings()) && proto.common.Decimals.toObject(includeInstance, f),
    createdat: (f = msg.getCreatedat()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    renounced: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    topholders: (f = msg.getTopholders()) && proto.common.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.AnalyticsSol}
 */
proto.common.AnalyticsSol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.AnalyticsSol;
  return proto.common.AnalyticsSol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.AnalyticsSol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.AnalyticsSol}
 */
proto.common.AnalyticsSol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setBurnedliquidity(value);
      break;
    case 2:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setPooledcrypto(value);
      break;
    case 3:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setPooledtokens(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMintauthority(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFreezeauthority(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHolders(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeployerwallet(value);
      break;
    case 8:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setDeployerholdings(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedat(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRenounced(value);
      break;
    case 11:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setTopholders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.AnalyticsSol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.AnalyticsSol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.AnalyticsSol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AnalyticsSol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBurnedliquidity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getPooledcrypto();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getPooledtokens();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDeployerholdings();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getCreatedat();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getTopholders();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional Decimals burnedLiquidity = 1;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsSol.prototype.getBurnedliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 1));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsSol} returns this
*/
proto.common.AnalyticsSol.prototype.setBurnedliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearBurnedliquidity = function() {
  return this.setBurnedliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasBurnedliquidity = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Decimals pooledCrypto = 2;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsSol.prototype.getPooledcrypto = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsSol} returns this
*/
proto.common.AnalyticsSol.prototype.setPooledcrypto = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearPooledcrypto = function() {
  return this.setPooledcrypto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasPooledcrypto = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Decimals pooledTokens = 3;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsSol.prototype.getPooledtokens = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 3));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsSol} returns this
*/
proto.common.AnalyticsSol.prototype.setPooledtokens = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearPooledtokens = function() {
  return this.setPooledtokens(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasPooledtokens = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool mintAuthority = 4;
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.getMintauthority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.setMintauthority = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearMintauthority = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasMintauthority = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool freezeAuthority = 5;
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.getFreezeauthority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.setFreezeauthority = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearFreezeauthority = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasFreezeauthority = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 holders = 6;
 * @return {number}
 */
proto.common.AnalyticsSol.prototype.getHolders = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.setHolders = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearHolders = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasHolders = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string deployerWallet = 7;
 * @return {string}
 */
proto.common.AnalyticsSol.prototype.getDeployerwallet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.setDeployerwallet = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearDeployerwallet = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasDeployerwallet = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional Decimals deployerHoldings = 8;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsSol.prototype.getDeployerholdings = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 8));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsSol} returns this
*/
proto.common.AnalyticsSol.prototype.setDeployerholdings = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearDeployerholdings = function() {
  return this.setDeployerholdings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasDeployerholdings = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp createdAt = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.common.AnalyticsSol.prototype.getCreatedat = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.common.AnalyticsSol} returns this
*/
proto.common.AnalyticsSol.prototype.setCreatedat = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearCreatedat = function() {
  return this.setCreatedat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasCreatedat = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional bool renounced = 10;
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.getRenounced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.setRenounced = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearRenounced = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasRenounced = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional Decimals topHolders = 11;
 * @return {?proto.common.Decimals}
 */
proto.common.AnalyticsSol.prototype.getTopholders = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 11));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AnalyticsSol} returns this
*/
proto.common.AnalyticsSol.prototype.setTopholders = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AnalyticsSol} returns this
 */
proto.common.AnalyticsSol.prototype.clearTopholders = function() {
  return this.setTopholders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AnalyticsSol.prototype.hasTopholders = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.Tokenomics.prototype.toObject = function(opt_includeInstance) {
  return proto.common.Tokenomics.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.Tokenomics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.Tokenomics.toObject = function(includeInstance, msg) {
  var f, obj = {
    priceincrypto: (f = msg.getPriceincrypto()) && proto.common.Decimals.toObject(includeInstance, f),
    liquiditycrypto: (f = msg.getLiquiditycrypto()) && proto.common.Decimals.toObject(includeInstance, f),
    initialliquiditycrypto: (f = msg.getInitialliquiditycrypto()) && proto.common.Decimals.toObject(includeInstance, f),
    mktcap: (f = msg.getMktcap()) && proto.common.Decimals.toObject(includeInstance, f),
    txns: jspb.Message.getFieldWithDefault(msg, 5, 0),
    volume: (f = msg.getVolume()) && proto.common.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.Tokenomics}
 */
proto.common.Tokenomics.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.Tokenomics;
  return proto.common.Tokenomics.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.Tokenomics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.Tokenomics}
 */
proto.common.Tokenomics.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setPriceincrypto(value);
      break;
    case 2:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setLiquiditycrypto(value);
      break;
    case 3:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setInitialliquiditycrypto(value);
      break;
    case 4:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setMktcap(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTxns(value);
      break;
    case 6:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setVolume(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.Tokenomics.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.Tokenomics.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.Tokenomics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.Tokenomics.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPriceincrypto();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getLiquiditycrypto();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getInitialliquiditycrypto();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getMktcap();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeUint32(
      5,
      f
    );
  }
  f = message.getVolume();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional Decimals priceInCrypto = 1;
 * @return {?proto.common.Decimals}
 */
proto.common.Tokenomics.prototype.getPriceincrypto = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 1));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.Tokenomics} returns this
*/
proto.common.Tokenomics.prototype.setPriceincrypto = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Tokenomics} returns this
 */
proto.common.Tokenomics.prototype.clearPriceincrypto = function() {
  return this.setPriceincrypto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Tokenomics.prototype.hasPriceincrypto = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Decimals liquidityCrypto = 2;
 * @return {?proto.common.Decimals}
 */
proto.common.Tokenomics.prototype.getLiquiditycrypto = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.Tokenomics} returns this
*/
proto.common.Tokenomics.prototype.setLiquiditycrypto = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Tokenomics} returns this
 */
proto.common.Tokenomics.prototype.clearLiquiditycrypto = function() {
  return this.setLiquiditycrypto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Tokenomics.prototype.hasLiquiditycrypto = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Decimals initialLiquidityCrypto = 3;
 * @return {?proto.common.Decimals}
 */
proto.common.Tokenomics.prototype.getInitialliquiditycrypto = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 3));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.Tokenomics} returns this
*/
proto.common.Tokenomics.prototype.setInitialliquiditycrypto = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Tokenomics} returns this
 */
proto.common.Tokenomics.prototype.clearInitialliquiditycrypto = function() {
  return this.setInitialliquiditycrypto(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Tokenomics.prototype.hasInitialliquiditycrypto = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Decimals mktCap = 4;
 * @return {?proto.common.Decimals}
 */
proto.common.Tokenomics.prototype.getMktcap = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.Tokenomics} returns this
*/
proto.common.Tokenomics.prototype.setMktcap = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Tokenomics} returns this
 */
proto.common.Tokenomics.prototype.clearMktcap = function() {
  return this.setMktcap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Tokenomics.prototype.hasMktcap = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uint32 txns = 5;
 * @return {number}
 */
proto.common.Tokenomics.prototype.getTxns = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.Tokenomics} returns this
 */
proto.common.Tokenomics.prototype.setTxns = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.Tokenomics} returns this
 */
proto.common.Tokenomics.prototype.clearTxns = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Tokenomics.prototype.hasTxns = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional Decimals volume = 6;
 * @return {?proto.common.Decimals}
 */
proto.common.Tokenomics.prototype.getVolume = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 6));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.Tokenomics} returns this
*/
proto.common.Tokenomics.prototype.setVolume = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Tokenomics} returns this
 */
proto.common.Tokenomics.prototype.clearVolume = function() {
  return this.setVolume(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Tokenomics.prototype.hasVolume = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.common.AuditReply.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.common.AuditReply.AuditCase = {
  AUDIT_NOT_SET: 0,
  AUDITSOL: 1,
  AUDITETH: 2
};

/**
 * @return {proto.common.AuditReply.AuditCase}
 */
proto.common.AuditReply.prototype.getAuditCase = function() {
  return /** @type {proto.common.AuditReply.AuditCase} */(jspb.Message.computeOneofCase(this, proto.common.AuditReply.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.AuditReply.prototype.toObject = function(opt_includeInstance) {
  return proto.common.AuditReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.AuditReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuditReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    auditsol: (f = msg.getAuditsol()) && proto.common.AuditSol.toObject(includeInstance, f),
    auditeth: (f = msg.getAuditeth()) && proto.common.AuditEth.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.AuditReply}
 */
proto.common.AuditReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.AuditReply;
  return proto.common.AuditReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.AuditReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.AuditReply}
 */
proto.common.AuditReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.common.AuditSol;
      reader.readMessage(value,proto.common.AuditSol.deserializeBinaryFromReader);
      msg.setAuditsol(value);
      break;
    case 2:
      var value = new proto.common.AuditEth;
      reader.readMessage(value,proto.common.AuditEth.deserializeBinaryFromReader);
      msg.setAuditeth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.AuditReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.AuditReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.AuditReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuditReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuditsol();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.common.AuditSol.serializeBinaryToWriter
    );
  }
  f = message.getAuditeth();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.AuditEth.serializeBinaryToWriter
    );
  }
};


/**
 * optional AuditSol auditSol = 1;
 * @return {?proto.common.AuditSol}
 */
proto.common.AuditReply.prototype.getAuditsol = function() {
  return /** @type{?proto.common.AuditSol} */ (
    jspb.Message.getWrapperField(this, proto.common.AuditSol, 1));
};


/**
 * @param {?proto.common.AuditSol|undefined} value
 * @return {!proto.common.AuditReply} returns this
*/
proto.common.AuditReply.prototype.setAuditsol = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.common.AuditReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AuditReply} returns this
 */
proto.common.AuditReply.prototype.clearAuditsol = function() {
  return this.setAuditsol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AuditReply.prototype.hasAuditsol = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional AuditEth auditEth = 2;
 * @return {?proto.common.AuditEth}
 */
proto.common.AuditReply.prototype.getAuditeth = function() {
  return /** @type{?proto.common.AuditEth} */ (
    jspb.Message.getWrapperField(this, proto.common.AuditEth, 2));
};


/**
 * @param {?proto.common.AuditEth|undefined} value
 * @return {!proto.common.AuditReply} returns this
*/
proto.common.AuditReply.prototype.setAuditeth = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.common.AuditReply.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AuditReply} returns this
 */
proto.common.AuditReply.prototype.clearAuditeth = function() {
  return this.setAuditeth(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AuditReply.prototype.hasAuditeth = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.AuditSol.prototype.toObject = function(opt_includeInstance) {
  return proto.common.AuditSol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.AuditSol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuditSol.toObject = function(includeInstance, msg) {
  var f, obj = {
    mintauthority: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    freezeauthority: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    lpburned: (f = msg.getLpburned()) && proto.common.Decimals.toObject(includeInstance, f),
    topholders: (f = msg.getTopholders()) && proto.common.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.AuditSol}
 */
proto.common.AuditSol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.AuditSol;
  return proto.common.AuditSol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.AuditSol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.AuditSol}
 */
proto.common.AuditSol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMintauthority(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFreezeauthority(value);
      break;
    case 3:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setLpburned(value);
      break;
    case 4:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setTopholders(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.AuditSol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.AuditSol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.AuditSol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuditSol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMintauthority();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getFreezeauthority();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getLpburned();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getTopholders();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool mintAuthority = 1;
 * @return {boolean}
 */
proto.common.AuditSol.prototype.getMintauthority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AuditSol} returns this
 */
proto.common.AuditSol.prototype.setMintauthority = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool freezeAuthority = 2;
 * @return {boolean}
 */
proto.common.AuditSol.prototype.getFreezeauthority = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AuditSol} returns this
 */
proto.common.AuditSol.prototype.setFreezeauthority = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional Decimals lpBurned = 3;
 * @return {?proto.common.Decimals}
 */
proto.common.AuditSol.prototype.getLpburned = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 3));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AuditSol} returns this
*/
proto.common.AuditSol.prototype.setLpburned = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AuditSol} returns this
 */
proto.common.AuditSol.prototype.clearLpburned = function() {
  return this.setLpburned(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AuditSol.prototype.hasLpburned = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Decimals topHolders = 4;
 * @return {?proto.common.Decimals}
 */
proto.common.AuditSol.prototype.getTopholders = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AuditSol} returns this
*/
proto.common.AuditSol.prototype.setTopholders = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AuditSol} returns this
 */
proto.common.AuditSol.prototype.clearTopholders = function() {
  return this.setTopholders(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AuditSol.prototype.hasTopholders = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.AuditEth.prototype.toObject = function(opt_includeInstance) {
  return proto.common.AuditEth.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.AuditEth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuditEth.toObject = function(includeInstance, msg) {
  var f, obj = {
    verifiedcontract: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    renounced: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    honeypot: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    lockedliquidity: (f = msg.getLockedliquidity()) && proto.common.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.AuditEth}
 */
proto.common.AuditEth.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.AuditEth;
  return proto.common.AuditEth.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.AuditEth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.AuditEth}
 */
proto.common.AuditEth.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVerifiedcontract(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRenounced(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHoneypot(value);
      break;
    case 4:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setLockedliquidity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.AuditEth.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.AuditEth.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.AuditEth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.AuditEth.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVerifiedcontract();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getRenounced();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getHoneypot();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getLockedliquidity();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool verifiedContract = 1;
 * @return {boolean}
 */
proto.common.AuditEth.prototype.getVerifiedcontract = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AuditEth} returns this
 */
proto.common.AuditEth.prototype.setVerifiedcontract = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool renounced = 2;
 * @return {boolean}
 */
proto.common.AuditEth.prototype.getRenounced = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AuditEth} returns this
 */
proto.common.AuditEth.prototype.setRenounced = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool honeypot = 3;
 * @return {boolean}
 */
proto.common.AuditEth.prototype.getHoneypot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.common.AuditEth} returns this
 */
proto.common.AuditEth.prototype.setHoneypot = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional Decimals lockedLiquidity = 4;
 * @return {?proto.common.Decimals}
 */
proto.common.AuditEth.prototype.getLockedliquidity = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 4));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.AuditEth} returns this
*/
proto.common.AuditEth.prototype.setLockedliquidity = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.AuditEth} returns this
 */
proto.common.AuditEth.prototype.clearLockedliquidity = function() {
  return this.setLockedliquidity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.AuditEth.prototype.hasLockedliquidity = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.Order.prototype.toObject = function(opt_includeInstance) {
  return proto.common.Order.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.Order} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.Order.toObject = function(includeInstance, msg) {
  var f, obj = {
    orderid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    amount: (f = msg.getAmount()) && proto.common.Decimals.toObject(includeInstance, f),
    amounttype: jspb.Message.getFieldWithDefault(msg, 3, 0),
    side: jspb.Message.getFieldWithDefault(msg, 4, 0),
    type: jspb.Message.getFieldWithDefault(msg, 5, 0),
    trigger: (f = msg.getTrigger()) && proto.common.OrderTrigger.toObject(includeInstance, f),
    settings: (f = msg.getSettings()) && proto.common.TransactionSettings.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.Order}
 */
proto.common.Order.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.Order;
  return proto.common.Order.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.Order} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.Order}
 */
proto.common.Order.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderid(value);
      break;
    case 2:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setAmount(value);
      break;
    case 3:
      var value = /** @type {!proto.enumeration.AmountType} */ (reader.readEnum());
      msg.setAmounttype(value);
      break;
    case 4:
      var value = /** @type {!proto.enumeration.Side} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 5:
      var value = /** @type {!proto.enumeration.OrderType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 6:
      var value = new proto.common.OrderTrigger;
      reader.readMessage(value,proto.common.OrderTrigger.deserializeBinaryFromReader);
      msg.setTrigger(value);
      break;
    case 7:
      var value = new proto.common.TransactionSettings;
      reader.readMessage(value,proto.common.TransactionSettings.deserializeBinaryFromReader);
      msg.setSettings(value);
      break;
    case 8:
      var value = /** @type {!proto.enumeration.OrderStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.Order.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.Order.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.Order} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.Order.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAmount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
  f = message.getAmounttype();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {!proto.enumeration.OrderType} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTrigger();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.common.OrderTrigger.serializeBinaryToWriter
    );
  }
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.common.TransactionSettings.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.enumeration.OrderStatus} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string orderId = 1;
 * @return {string}
 */
proto.common.Order.prototype.getOrderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.setOrderid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.clearOrderid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Order.prototype.hasOrderid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Decimals amount = 2;
 * @return {?proto.common.Decimals}
 */
proto.common.Order.prototype.getAmount = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.Order} returns this
*/
proto.common.Order.prototype.setAmount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.clearAmount = function() {
  return this.setAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Order.prototype.hasAmount = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional enumeration.AmountType amountType = 3;
 * @return {!proto.enumeration.AmountType}
 */
proto.common.Order.prototype.getAmounttype = function() {
  return /** @type {!proto.enumeration.AmountType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.enumeration.AmountType} value
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.setAmounttype = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional enumeration.Side side = 4;
 * @return {!proto.enumeration.Side}
 */
proto.common.Order.prototype.getSide = function() {
  return /** @type {!proto.enumeration.Side} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.enumeration.Side} value
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional enumeration.OrderType type = 5;
 * @return {!proto.enumeration.OrderType}
 */
proto.common.Order.prototype.getType = function() {
  return /** @type {!proto.enumeration.OrderType} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.enumeration.OrderType} value
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.setType = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.clearType = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Order.prototype.hasType = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional OrderTrigger trigger = 6;
 * @return {?proto.common.OrderTrigger}
 */
proto.common.Order.prototype.getTrigger = function() {
  return /** @type{?proto.common.OrderTrigger} */ (
    jspb.Message.getWrapperField(this, proto.common.OrderTrigger, 6));
};


/**
 * @param {?proto.common.OrderTrigger|undefined} value
 * @return {!proto.common.Order} returns this
*/
proto.common.Order.prototype.setTrigger = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.clearTrigger = function() {
  return this.setTrigger(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Order.prototype.hasTrigger = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional TransactionSettings settings = 7;
 * @return {?proto.common.TransactionSettings}
 */
proto.common.Order.prototype.getSettings = function() {
  return /** @type{?proto.common.TransactionSettings} */ (
    jspb.Message.getWrapperField(this, proto.common.TransactionSettings, 7));
};


/**
 * @param {?proto.common.TransactionSettings|undefined} value
 * @return {!proto.common.Order} returns this
*/
proto.common.Order.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Order.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional enumeration.OrderStatus status = 8;
 * @return {!proto.enumeration.OrderStatus}
 */
proto.common.Order.prototype.getStatus = function() {
  return /** @type {!proto.enumeration.OrderStatus} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.enumeration.OrderStatus} value
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.setStatus = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.common.Order} returns this
 */
proto.common.Order.prototype.clearStatus = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.Order.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.OrderTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.common.OrderTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.OrderTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.OrderTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: (f = msg.getValue()) && proto.common.Decimals.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.OrderTrigger}
 */
proto.common.OrderTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.OrderTrigger;
  return proto.common.OrderTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.OrderTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.OrderTrigger}
 */
proto.common.OrderTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.enumeration.OrderTriggerType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = new proto.common.Decimals;
      reader.readMessage(value,proto.common.Decimals.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.OrderTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.OrderTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.OrderTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.OrderTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.common.Decimals.serializeBinaryToWriter
    );
  }
};


/**
 * optional enumeration.OrderTriggerType type = 1;
 * @return {!proto.enumeration.OrderTriggerType}
 */
proto.common.OrderTrigger.prototype.getType = function() {
  return /** @type {!proto.enumeration.OrderTriggerType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.enumeration.OrderTriggerType} value
 * @return {!proto.common.OrderTrigger} returns this
 */
proto.common.OrderTrigger.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional Decimals value = 2;
 * @return {?proto.common.Decimals}
 */
proto.common.OrderTrigger.prototype.getValue = function() {
  return /** @type{?proto.common.Decimals} */ (
    jspb.Message.getWrapperField(this, proto.common.Decimals, 2));
};


/**
 * @param {?proto.common.Decimals|undefined} value
 * @return {!proto.common.OrderTrigger} returns this
*/
proto.common.OrderTrigger.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.common.OrderTrigger} returns this
 */
proto.common.OrderTrigger.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.common.OrderTrigger.prototype.hasValue = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.common.Decimals.prototype.toObject = function(opt_includeInstance) {
  return proto.common.Decimals.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.common.Decimals} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.Decimals.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, 0),
    exp: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.common.Decimals}
 */
proto.common.Decimals.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.common.Decimals;
  return proto.common.Decimals.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.common.Decimals} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.common.Decimals}
 */
proto.common.Decimals.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSint32());
      msg.setExp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.common.Decimals.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.common.Decimals.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.common.Decimals} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.common.Decimals.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getExp();
  if (f !== 0) {
    writer.writeSint32(
      2,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.common.Decimals.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.Decimals} returns this
 */
proto.common.Decimals.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional sint32 exp = 2;
 * @return {number}
 */
proto.common.Decimals.prototype.getExp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.common.Decimals} returns this
 */
proto.common.Decimals.prototype.setExp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.common);
